import React from "react";

const FeatureCard = ({ title, subtitle }) => (
  <div className="bg-black/25 backdrop-blur-md p-5 rounded-xl border border-white/10">
    <span className="text-white text-2xl font-bold block mb-1">{title}</span>
    <span className="text-secondary text-[10px] font-bold uppercase tracking-widest">
      {subtitle}
    </span>
  </div>
);

const HeroSection = () => {
  return (
    <section className="md:w-1/2 relative flex items-center justify-center p-12 overflow-hidden hero-gradient">
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://lh3.googleusercontent.com/aida-public/AB6AXuAKSYalnBLW4uoKvIPkzKeRmsRzc34abOm6Vu_wk6TxEUtNn7RywzVRj2HaF2QLvCY2oQahEi3b-PYUu7nPIj3pzwjFkp92yZZb4dVqx19jWfsI6gX1Qi_fLAnI8XlqTzpmEzwDc8I4aVQAV71BjNYHBanZqjVfSR5u8YUwyJxfvux0fDUoYcVu1Z5eoBghd6W6LJMn1EQ5Glq0lB2jt1cfqHTVeFRhEeNeunNYlfgQK1j5AH5VEeqJ3MzNruFZjGFs34i1bGJRVw"
          alt="abstract digital network"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-lg text-white">
        <div className="mb-10 flex items-center gap-4">
          <div className="bg-white p-2.5 rounded-xl shadow-xl">
            <span className="material-symbols-outlined text-primary text-3xl">
              biotech
            </span>
          </div>
          <span className="text-2xl font-extrabold">Lab Planning</span>
        </div>

        <h1 className="text-5xl font-extrabold mb-6 leading-tight">
          Enterprise EMC Lab Orchestration.
        </h1>

        <p className="text-white/80 text-lg mb-10">
          Streamline compliance testing and laboratory resource management with
          high-precision planning.
        </p>

       
        <div className="flex flex-wrap justify-center gap-4">
          <FeatureCard title="ISO / IEC 17025" subtitle="Competence Standard" />
        </div>
      </div>
    </section>
  );
};

export default React.memo(HeroSection);